import { useNotification } from '@the-platform-group/component-library/Notification'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { approveProcessingQueue, getProcessingQueue, rejectProcessingQueue } from 'services/nobo'

export const PROCESSING_QUEUE_QUERY_KEY = 'getProcessingQueue'

const useProcessingQueueData = () => {
  const { data, isFetching } = useQuery({
    queryKey: [PROCESSING_QUEUE_QUERY_KEY],
    queryFn: getProcessingQueue,
    initialData: [],
  })

  return {
    data,
    isLoading: isFetching,
  }
}

const useProcessingQueueMutation = () => {
  const { createNotification } = useNotification()
  const queryClient = useQueryClient()

  const approveProcessingQueueMutation = useMutation({
    mutationKey: ['approveProcessingQueue'],
    mutationFn: approveProcessingQueue,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PROCESSING_QUEUE_QUERY_KEY] })
    },
    onError: error => {
      createNotification({
        message: `Error approving processing queue: ${error.message}`,
        variant: 'error',
      })
    },
  })

  const rejectProcessingQueueMutation = useMutation({
    mutationKey: ['rejectProcessingQueue'],
    mutationFn: rejectProcessingQueue,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PROCESSING_QUEUE_QUERY_KEY] })
    },
    onError: error => {
      createNotification({
        message: `Error rejecting processing queue: ${error.message}`,
        variant: 'error',
      })
    },
  })

  return {
    approveProcessingQueueMutation,
    rejectProcessingQueueMutation,
  }
}

export { useProcessingQueueData, useProcessingQueueMutation }
